import { render, staticRenderFns } from "./cusThree.vue?vue&type=template&id=4635cd9a&scoped=true"
import script from "./cusThree.vue?vue&type=script&lang=js"
export * from "./cusThree.vue?vue&type=script&lang=js"
import style0 from "./cusThree.vue?vue&type=style&index=0&id=4635cd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635cd9a",
  null
  
)

export default component.exports